import app from "@/app";
export { Vec2 } from "./vec2";
import DragHandleController from "./drag-handle-controller";
import DraggableController from "./draggable-controller";
export * from "./outside-tap-detector";

app.register("draggable", DraggableController);
app.register('drag-handle', DragHandleController);
